import { Component, OnInit } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { DynamoUtilityService } from "./dynamo-utility.service";
import { DynamoUtilityOperation, DynamoUtilityResponse } from "../../Models/DynamoUtility";

@Component({
  selector: 'app-dynamo-utility',
  templateUrl: './dynamo-utility.component.html',
  styleUrls: ['./dynamo-utility.component.scss'],
  standalone: false,
})
export class DynamoUtilityComponent implements OnInit {
  tables: string[] = [];
  tableName = '';
  operation: DynamoUtilityOperation = 'upsert';
  itemsJson = '';

  jsonError = '';
  errorMessage = '';
  result: DynamoUtilityResponse | null = null;
  confirmOpen = false;
  isSubmitting = false;
  itemCount = 0;

  constructor(private dynamoUtilityService: DynamoUtilityService) {}

  ngOnInit(): void {
    this.dynamoUtilityService.getTables().subscribe({
      next: (tables) => this.tables = tables,
      error: (err) => this.errorMessage = 'Failed to load tables. ' + this.describeError(err)
    });
  }

  get canSubmit(): boolean {
    return !!this.tableName && !!this.itemsJson.trim() && !this.isSubmitting;
  }

  formatJson(): void {
    const parsed = this.parseJson();
    if (parsed !== undefined) {
      this.itemsJson = JSON.stringify(parsed, null, 2);
    }
  }

  // Server-side validation is authoritative; this only catches malformed JSON and counts items for the confirmation
  openConfirm(): void {
    this.errorMessage = '';
    this.result = null;
    const parsed = this.parseJson();
    if (parsed === undefined) {
      return;
    }
    this.itemCount = Array.isArray(parsed) ? parsed.length : 1;
    this.confirmOpen = true;
  }

  closeConfirm(): void {
    this.confirmOpen = false;
  }

  execute(): void {
    this.confirmOpen = false;
    this.isSubmitting = true;
    this.dynamoUtilityService.execute({
      tableName: this.tableName,
      operation: this.operation,
      itemsJson: this.itemsJson,
    }).subscribe({
      next: (res) => {
        this.result = res;
        this.isSubmitting = false;
      },
      error: (err) => {
        this.errorMessage = this.describeError(err);
        this.isSubmitting = false;
      }
    });
  }

  private parseJson(): unknown {
    this.jsonError = '';
    try {
      return JSON.parse(this.itemsJson);
    } catch (e) {
      this.jsonError = 'Invalid JSON: ' + (e as Error).message;
      return undefined;
    }
  }

  private describeError(err: HttpErrorResponse): string {
    if (err.status === 401) {
      return 'Your sign-in could not be verified or has expired. Sign out and sign in again.';
    }
    if (err.status === 403) {
      return 'You do not have access to the DynamoDB Utility. Access requires membership of the users_csp_admin group.';
    }
    return typeof err.error === 'string' && err.error ? err.error : err.message;
  }
}
